<template>
  <div  class="alert alert-info alert-dismissable">
    <button aria-hidden="true" data-dismiss="alert" class="close" type="button">×</button>
    {{message}}
  </div>
</template>

<script>
  export default {
    props: ['message']
  }
</script>




// WEBPACK FOOTER //
// DismissableAlert.vue?0ce8caea